// reducers/index.js
import { combineReducers } from '@reduxjs/toolkit';
import planoReducer from './plano'; // Ajuste o caminho conforme necessário
import utilsReducer from './utils';

const rootReducer = combineReducers({
    plano: planoReducer,
    utils: utilsReducer,
});

export default rootReducer;
